$(document).ready(function () {
    $('.accordion-button').click(function () {
      const $button = $(this);
      const expanded = $button.attr('aria-expanded') === 'true';
      $button.attr('aria-expanded', !expanded);
      
      const $content = $button.next();
      if (expanded) {
        $content.attr('hidden', true);
      } else {
        $content.removeAttr('hidden');
      }
    });
  });
  
  
  $(document).ready(function () {
    var existCondition = setInterval(function () {
      if ($('button#size-chart-product').length) {
        clearInterval(existCondition);
        runMyFunctionmenupd();
      }
    }, 200);
  
    function runMyFunctionmenupd() {
      $('button#size-chart-product').attr('aria-haspopup', 'dialog');
    }
  });

  $(document).ready(function() {
    $(".SizeChart__table").each(function() {
        var designerText = $(this).closest('.SizeChart').find('.SizeChart__designer').text(); // Get the content from the designer text
        var caption = $("<caption>").addClass("u-visually-hidden").text(designerText); // Create a caption element

        $(this).prepend(caption); // Insert the caption before the table body
    });
});

$(document).ready(function() {
    $('div#product-badges .badge svg').eq(0).attr('aria-label', 'Price Tag').attr('aria-haspopup', 'dialog');
  
    $('div#product-badges .badge svg').eq(1).attr('aria-label', 'Free delivery truck').attr('aria-haspopup', 'dialog');
  
    $('div#product-badges .badge svg').eq(2).attr('aria-label', 'Guaranteed tag').attr('aria-haspopup', 'dialog');
  
    $('div#product-badges .badge svg').eq(3).attr('aria-label', 'Returns Tag').attr('aria-haspopup', 'dialog');

    $('div#product-badges .badge svg').attr('role', 'button');
  });
  
  $(document).ready(function() {
    var sizeMap = {
      'XS': 'Extra small',
      'S': 'Small',
      'M': 'Medium',
      'L': 'Large',
      'XL': 'Extra large',
      'XXL': '2X Large',
      'XXXL': '3X Large'
    };
  
    $('ul.SizeSwatchList li').each(function() {
      var labelText = $(this).find('label').text().trim(); 
      var inputValue = $(this).find('input').val() || ''; // Get the value of the input if it exists
      var ariaLabel = 'Size ' + (sizeMap[labelText] || labelText); // Fallback to labelText if not in sizeMap
  
      // Only add the value if it's not already part of the label text
      if (inputValue && !ariaLabel.includes(inputValue)) {
        ariaLabel += ' ' + inputValue;
      }
  
      $(this).find('input').attr('aria-label', ariaLabel);
    });
  });
  
  // $(document).ready(function() {
  //   var sizeMap = {
  //     'XS': 'Extra small',
  //     'S': 'Small',
  //     'M': 'Medium',
  //     'L': 'Large',
  //     'XL': 'Extra large',
  //     'XXL': '2X Large',
  //     'XXXL': '3X Large'
  //   };
  
  //   $('ul.SizeSwatchList li').each(function() {
  //     var labelText = $(this).find('label').text().trim(); 
  //     var ariaLabel = 'Size ' + sizeMap[labelText];  
  //     $(this).find('input').attr('aria-label', ariaLabel);
  //   });
  // });
  